import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "container-fluid" };
var _hoisted_2 = {
    class: "card my-5 mx-auto",
    style: { "max-width": "420px" }
};
var _hoisted_3 = { class: "card-body" };
var _hoisted_4 = { class: "mb-3" };
var _hoisted_5 = { class: "d-flex justify-content-between mb-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "card-title" }, "Crear Plataforma", -1)),
                _createElementVNode("form", {
                    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
                    //@ts-ignore
                    function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return (_ctx.create && _ctx.create.apply(_ctx, args));
                    }, ["prevent"]))
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "name",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((_ctx.platform.name) = $event); }),
                            placeholder: "Nombre",
                            required: ""
                        }, null, 512), [
                            [_vModelText, _ctx.platform.name]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_router_link, {
                            to: "/admin/platforms",
                            class: "btn btn-link"
                        }, {
                            default: _withCtx(function () { return _cache[2] || (_cache[2] = [
                                _createTextVNode("Cancelar")
                            ]); }),
                            _: 1
                        }),
                        _cache[3] || (_cache[3] = _createElementVNode("button", {
                            type: "submit",
                            class: "btn btn-primary"
                        }, "Guardar", -1))
                    ])
                ], 32)
            ])
        ])
    ]));
}
